<div class="asset-creation-container">
  <div class="asset-form-wrapper">
    <div *ngIf="successFlag" class="success-message">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <span>{{ description }}</span>
    </div>
    <div *ngIf="errorFlag" class="error-message">
      <mat-icon class="error-icon">error</mat-icon>
      <span>{{ description }}</span>
    </div>

    <form [formGroup]="updateAssetForm" class="asset-form">
      <!-- Header Section -->
      <div class="row">
        <h1 class="title">Update Asset</h1>
      </div>

      <!-- Asset Search Section -->
      <div class="form-section asset-search-section">
        <h2 class="section-title">
          <mat-icon>search</mat-icon>
          Asset Search
        </h2>
        <div class="form-row">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Update Category</mat-label>
              <select
                matNativeControl
                required
                [(ngModel)]="selectUpdateCategory"
                formControlName="updateCategory"
              >
                <option value="assignEmp">Transfer Asset to Employee</option>
                <option value="updateAsset">Update Asset</option>
              </select>
              <mat-hint>Choose the type of update you want to perform</mat-hint>
            </mat-form-field>
          </div>
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Search Asset with ID</mat-label>
              <input
                matInput
                formControlName="assetId"
                (change)="searchAsset($event)"
                (keydown.enter)="$event.preventDefault(); searchAsset($event)"
                required
              />
              <mat-hint>Enter the asset ID to search and update</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Assign to Employee Section -->
      <div
        class="form-section assign-employee-section"
        *ngIf="selectUpdateCategory === 'assignEmp'"
      >
        <h2 class="section-title">
          <mat-icon>person_add</mat-icon>
          Assign to Employee
        </h2>

        <!-- Current Employee Details -->
        <div class="subsection">
          <h3 class="subsection-title">Current Assignment</h3>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Asset Assigned to Employee</mat-label>
                <input matInput formControlName="currentEmp" readonly />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Asset Type</mat-label>
                <input matInput formControlName="assetType" readonly />
              </mat-form-field>
            </div>
            <div
              class="form-field-wrapper"
              *ngIf="
                updateAssetForm.get('assetType')?.value === 'Laptop' ||
                updateAssetForm.get('assetType')?.value === 'Monitor' ||
                updateAssetForm.get('assetType')?.value === 'Mobile' ||
                updateAssetForm.get('assetType')?.value === 'Other'
              "
            >
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Model</mat-label>
                <input
                  matInput
                  [value]="
                    updateAssetForm
                      .get('assetElectronic')
                      ?.get('electronicModel')?.value
                  "
                  readonly
                />
              </mat-form-field>
            </div>
            <div
              class="form-field-wrapper"
              *ngIf="
                updateAssetForm.get('assetType')?.value === 'Car' ||
                updateAssetForm.get('assetType')?.value === 'car'
              "
            >
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Registration Number</mat-label>
                <input
                  matInput
                  [value]="
                    updateAssetForm.get('assetCar')?.get('number')?.value
                  "
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Current Employee Assign Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="currentEmpAssignedDate"
                  formControlName="empAssignedDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="currentEmpAssignedDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #currentEmpAssignedDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Current Employee End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="currentEmpEndDate"
                  formControlName="currentEmpEndDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="currentEmpEndDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #currentEmpEndDate></mat-datepicker>
                <mat-error
                  *ngIf="
                    updateAssetForm
                      .get('currentEmpEndDate')
                      ?.hasError('required')
                  "
                >
                  Current employee end date is required
                </mat-error>
                <mat-error
                  *ngIf="
                    updateAssetForm
                      .get('currentEmpEndDate')
                      ?.hasError('dateOrder')
                  "
                >
                  Current end date must be later than current start date
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- New Employee Assignment -->
        <div class="subsection">
          <h3 class="subsection-title">New Assignment</h3>
          <div class="form-row">
            <div class="form-field-wrapper employee-field">
              <app-emp-name
                [filterEmpName]="filterEmpName"
                (empName)="empNameSelected($event)"
              ></app-emp-name>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>New Employee Assign Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="newEmpAssignedDate"
                  formControlName="newEmpAssignedDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="newEmpAssignedDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #newEmpAssignedDate></mat-datepicker>
                <mat-error
                  *ngIf="
                    updateAssetForm
                      .get('newEmpAssignedDate')
                      ?.hasError('required')
                  "
                >
                  New employee assign date is required
                </mat-error>
                <mat-error
                  *ngIf="
                    updateAssetForm
                      .get('newEmpAssignedDate')
                      ?.hasError('dateOrder')
                  "
                >
                  New employee assign date must be later than current employee
                  end date
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Status</mat-label>
                <select matNativeControl required formControlName="status">
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Assigned">Assigned</option>
                </select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field-wrapper comments-field">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Comments</mat-label>
                <textarea
                  matInput
                  formControlName="comments"
                  rows="3"
                ></textarea>
                <mat-hint>Provide any additional comments or notes</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Submit Button for Assign -->
        <div class="form-actions">
          <button
            mat-raised-button
            color="primary"
            class="submit-button"
            (click)="assignAsset()"
            [disabled]="!isAssignFormValid"
            type="button"
          >
            <mat-icon>person_add</mat-icon>
            Transfer Asset
          </button>
        </div>
      </div>

      <!-- Update Asset Details Section -->
      <div
        class="form-section update-details-section"
        *ngIf="selectUpdateCategory === 'updateAsset'"
      >
        <h2 class="section-title">
          <mat-icon>update</mat-icon>
          Update Asset Details
        </h2>

        <!-- Car Details Section -->
        <div
          class="subsection car-details-section"
          formGroupName="assetCar"
          *ngIf="updateAssetForm.get('assetType')?.value === 'Car'"
        >
          <h3 class="subsection-title">
            <mat-icon>directions_car</mat-icon>
            Car Details
          </h3>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Make</mat-label>
                <input matInput formControlName="make" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Model</mat-label>
                <input matInput formControlName="model" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Registration Number</mat-label>
                <input matInput formControlName="number" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Color</mat-label>
                <input matInput formControlName="color" />
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Chasis Number</mat-label>
                <input matInput formControlName="chasisNumber" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Fuel Type</mat-label>
                <select matNativeControl formControlName="fuelType">
                  <option value="petrol">Petrol</option>
                  <option value="diesel">Diesel</option>
                  <option value="electric">Electric</option>
                  <option value="hybrid">Hybrid</option>
                </select>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Carbon Emission</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="carbonEmission"
                />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Catalogue Price</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="cataloguePrice"
                />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Category</mat-label>
                <select
                  matNativeControl
                  required
                  formControlName="assetCategory"
                  [(ngModel)]="assetCategory"
                >
                  <option value="Leased">Leased</option>
                  <option value="Own">Own</option>
                  <option value="Rent">Rent</option>
                </select>
              </mat-form-field>
            </div>
            <div
              class="form-field-wrapper"
              *ngIf="assetCategory === 'Leased' || assetCategory === 'Rent'"
            >
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Lease End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="leaseEndDate"
                  formControlName="leaseEndDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="leaseEndDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #leaseEndDate></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row"></div>
        </div>

        <div
          class="subsection asset-lifecycle-section"
          *ngIf="
            updateAssetForm.get('assetType')?.value === 'Car' ||
            updateAssetForm.get('assetType')?.value === 'Laptop' ||
            updateAssetForm.get('assetType')?.value === 'Monitor' ||
            updateAssetForm.get('assetType')?.value === 'Mobile' ||
            updateAssetForm.get('assetType')?.value === 'Other'
          "
        >
          <h3 class="subsection-title">Asset Lifecycle</h3>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Asset Start Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="assetStartDatePicker"
                  formControlName="assetStartDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="assetStartDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #assetStartDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Asset End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="assetEndDatePicker"
                  formControlName="assetEndDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="assetEndDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #assetEndDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-checkbox formControlName="insurance">Insurance</mat-checkbox>
            </div>
            <div class="form-field-wrapper">
              <mat-checkbox formControlName="warranty">Warranty</mat-checkbox>
            </div>
          </div>
          <div class="form-row" *ngIf="updateAssetForm.get('insurance')?.value">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Insurance Start Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="insuStartDatePicker"
                  formControlName="insuStartDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="insuStartDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #insuStartDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Insurance End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="insuEndDatePicker"
                  formControlName="insuEndDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="insuEndDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #insuEndDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row" *ngIf="updateAssetForm.get('warranty')?.value">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Warranty Start Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="warStartDatePicker"
                  formControlName="warStartDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="warStartDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #warStartDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Warranty End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="warEndDatePicker"
                  formControlName="warEndDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="warEndDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #warEndDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- SIM Details -->
        <div class="form-row" *ngIf="selectedAsset === 'SIM'">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Mobile Number</mat-label>
              <input matInput formControlName="mobileNumber" />
            </mat-form-field>
          </div>
        </div>

        <!-- Fuel Card Details -->
        <div class="form-row" *ngIf="selectedAsset === 'Fuel Card'">
          <div class="form-field-wrapper">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Fuel Card</mat-label>
              <input matInput formControlName="fuelCard" />
            </mat-form-field>
          </div>
        </div>

        <!-- Electronic Device Details Section -->
        <div
          class="subsection electronic-details-section"
          formGroupName="assetElectronic"
          *ngIf="
            updateAssetForm.get('assetType')?.value === 'Laptop' ||
            updateAssetForm.get('assetType')?.value === 'Monitor' ||
            updateAssetForm.get('assetType')?.value === 'Mobile' ||
            selectedAsset === 'Other'
          "
        >
          <h3 class="subsection-title">
            <mat-icon>devices</mat-icon>
            Device Details
          </h3>
          <div class="form-row">
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Model</mat-label>
                <input matInput formControlName="electronicModel" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Serial Number</mat-label>
                <input matInput formControlName="electronicSerialNumber" />
              </mat-form-field>
            </div>
            <div class="form-field-wrapper">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Price</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="electronicPrice"
                />
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Comments for Update Asset -->
        <div class="form-row">
          <div class="form-field-wrapper comments-field">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Comments</mat-label>
              <textarea matInput formControlName="comments" rows="3"></textarea>
              <mat-hint
                >Provide any additional comments or notes for the
                update</mat-hint
              >
            </mat-form-field>
          </div>
        </div>

        <!-- Submit Button for Update Asset -->
        <div class="form-actions">
          <button
            mat-raised-button
            color="primary"
            class="submit-button"
            (click)="
              updateAssetForm.get('assetType')?.value === 'Car'
                ? updateCarAsset()
                : updateElectronicAsset()
            "
            [disabled]="!isUpdateFormValid"
            type="button"
          >
            <mat-icon>update</mat-icon>
            Update Asset
          </button>
        </div>
      </div>

      <!-- File Upload Section -->
      <div
        class="form-section file-upload-section"
        *ngIf="
          selectUpdateCategory === 'updateAsset' &&
          (updateAssetForm.get('assetType')?.value === 'Car' ||
            updateAssetForm.get('assetType')?.value === 'Laptop' ||
            updateAssetForm.get('assetType')?.value === 'Monitor' ||
            updateAssetForm.get('assetType')?.value === 'Mobile' ||
            selectedAsset === 'Other')
        "
      >
        <h2 class="section-title">
          <mat-icon>attach_file</mat-icon>
          File Upload
        </h2>
        <app-upload
          [fileList]="fileList"
          [category]="searchAssetId"
        ></app-upload>
      </div>
    </form>
  </div>
</div>
